import { Button } from 'antd';
import styled from 'styled-components';
import { sizes } from 'theme';

export const StyledPrimaryButton = styled(Button)`
    && {
        border-radius: ${sizes.radiusMd}px;
        background-color: var(--brand-6);
        color: var(--gray-1);
        font-size: 14px;
        line-height: 22px;

        &:hover,
        &:focus {
            background-color: var(--brand-5);
            color: var(--gray-1);
        }

        &:focus {
            outline: 1px solid var(--brand-7);
            border-color: transparent;
        }

        &:active {
            background-color: var(--brand-7);
        }

        &:disabled {
            cursor: disabled;
            outline: none;
            border-color: var(--gray-5);
            color: var(--gray-6);
            background-color: var(--gray-3);
        }
    }

    &:focus:not(:disabled),
    &:active:not(:disabled) {
        box-shadow: none !important;
    }

    &:focus,
    &:active,
    &.ant-btn:focus,
    &.ant-btn:active {
        outline: none;
        box-shadow: none;
        border-color: var(--brand-5);
    }
`;

export const StyledDefaultButton = styled(Button)`
    && {
        border-radius: ${sizes.radiusMd}px;
        border-color: var(--gray-5);
        color: var(--gray-9);

        &:hover,
        &:focus {
            color: var(--brand-5);
            border-color: var(--gray-5);
        }

        &:focus,
        &:active {
            outline: 1px solid var(--brand-7);
            color: var(--brand-7);
        }

        &:disabled {
            cursor: disabled;
            outline: none;
            border-color: var(--gray-5);
            color: var(--gray-6);
            background-color: var(--gray-3);
        }
    }

    &:focus:not(:disabled),
    &:active:not(:disabled) {
        box-shadow: none !important;
    }

    &:focus,
    &:active,
    &.ant-btn:focus,
    &.ant-btn:active {
        outline: none;
        box-shadow: none;
        border-color: var(--brand-5);
    }
`;

export const StyledErrorButton = styled(Button)`
    && {
        border-radius: ${sizes.radiusMd}px;
        background-color: var(--dust-red-5);
        color: var(--gray-1);
        font-size: 14px;
        line-height: 22px;

        &:hover,
        &:focus {
            background-color: var(--dust-red-4);
            color: var(--gray-1);
            border-color: transparent;
        }

        &:focus,
        &:active {
            outline: 1px solid var(--dust-red-6);
        }

        &:disabled {
            cursor: disabled;
            outline: none;
            border-color: var(--gray-5);
            color: var(--gray-6);
            background-color: var(--gray-3);
        }
    }

    &:focus:not(:disabled),
    &:active:not(:disabled) {
        box-shadow: none !important;
    }

    &:focus,
    &:active,
    &.ant-btn:focus,
    &.ant-btn:active {
        outline: none;
        box-shadow: none;
        border-color: var(--dust-red-6);
    }
`;

export const StyledLinkButton = styled(Button)`
    display: inline;
    max-width: max-content !important;
    all: unset;
    color: var(--gray-9);
    cursor: pointer;
    background: transparent !important;

    &:hover:not(:disabled) {
        color: var(--brand-5);
    }

    &:active:not(:disabled),
    &:focus:not(:disabled) {
        color: var(--brand-7);
    }

    &:disabled {
        color: var(--gray-6) !important;
        pointer-events: none;
    }
`;

export const StyledSuccessButton = styled(Button)`
    && {
        border-radius: ${sizes.radiusMd}px;
        background-color: var(--polar-green-6);
        color: var(--gray-1);
        font-size: 14px;
        line-height: 22px;

        &:hover,
        &:focus {
            background-color: var(--polar-green-7);
            color: var(--gray-1);
        }

        &:focus {
            outline: 1px solid var(--polar-green-7);
            border-color: transparent;
        }

        &:active {
            background-color: var(--polar-green-7);
        }

        &:disabled {
            cursor: disabled;
            outline: none;
            border-color: var(--gray-5);
            color: var(--gray-6);
            background-color: var(--gray-3);
        }
    }

    &:focus:not(:disabled),
    &:active:not(:disabled) {
        box-shadow: none !important;
    }

    &:focus,
    &:active,
    &.ant-btn:focus,
    &.ant-btn:active {
        /* outline: none; */
        box-shadow: none;
        background-color: var(--polar-green-7);
    }
`;

export const StyledAssignButton = styled(Button)`
    border-color: var(--brand-6);
    color: var(--brand-6);
    border-radius: ${sizes.radiusMd}px;
`;

export const StyledOutlinedButton = styled(Button)`
    && {
        border-radius: ${sizes.radiusMd}px;
        border-color: var(--brand-6);
        color: var(--brand-6);

        &:hover,
        &:focus {
            border-color: var(--brand-5);
            color: var(--brand-5);
        }

        &:active {
            border-color: var(--brand-7);
            color: var(--brand-7);
        }

        &:disabled {
            cursor: disabled;
            outline: none;
            border-color: var(--gray-5);
            color: var(--gray-6);
            background-color: var(--gray-3);
        }
    }

    &:focus:not(:disabled),
    &:active:not(:disabled) {
        box-shadow: none !important;
    }

    &:focus,
    &:active,
    &.ant-btn:focus,
    &.ant-btn:active {
        outline: none;
        box-shadow: none;
        border-color: var(--brand-7);
    }
`;
